import React from 'react';
import { useClassName } from '../hooks';
import { TileKitProvider } from '../TileKit';
import { Vehicle } from '../types';
import './Shell.scss';

type ShellProps = {
  cdnBlobUrl?: string;
  cdnUrl?: string;
  className?: string;
  vehicle?: Vehicle;
};

const Shell: React.FC<React.PropsWithChildren<ShellProps>> = ({
  children,
  className,
  ...props
}) => {
  const cx = useClassName('tk-shell', className);

  return (
    <TileKitProvider {...props}>
      <div className={cx}>{children}</div>
    </TileKitProvider>
  );
};

export default Shell;
